import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { intl } from '../../../../modules/Intl/IntlGlobalWrapper';
import { saveConfig, saveGlobalConfig, updateEnabledColors, updateFieldColors } from '../../FilterActions';
import { CustomSelect } from '../common';
import textUtils from '../../../../util/text';
import { hasLabels } from '../../../../util/customFieldsUtils';

class EnableColors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: []
    };
  }

  componentDidMount() {
    this.updateState();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.customFields != this.props.customFields) {
      this.updateState();
    }
  }

  updateState() {
    const items = _(this.props.customFields)
      .map(cf => {
        const allHistorical = _(cf.options)
          .filter(o => o._id !== 'no-option')
          .every(o => o.history);
        if (allHistorical) {
          return null;
        }

        return {
          label: cf.name,
          value: cf.extId
        };
      })
      .filter(cf => !!cf)
      .value();

    const { dashboard } = this.props;
    const app = dashboard && dashboard.application || this.props.app;
    const fileApp = (app === 'file' && !dashboard.isCsv) && (dashboard.isAzure ? 'azure' : 'jira');

    if (!dashboard.isCsv && hasLabels(app, dashboard.selectedFields)) {
      items.unshift({
        label: textUtils.format(intl.formatMessage({ id: `${fileApp || app}.label` }), '', true, false, 'capitalize'),
        value: 'labels'
      });
    }

    items.push({
      label: 'Disabled',
      value: 'disabled'
    });

    this.setState({
      items
    });
  }

  handleChange = ev => {
    if (this.props.global) {
      this.props.updateEnabledColors(ev);
      this.props.updateFieldColors(ev);
      this.props.saveGlobalConfig();
    } else {
      this.props.updateEnabledColors(ev, this.props.chart);
      this.props.updateFieldColors(ev, this.props.chart);
      this.props.saveConfig();
    }
  };

  render() {
    const { items } = this.state;

    return (
      <CustomSelect
        name={'enableColor'}
        title={'Colors'}
        items={items}
        value={this.props.global ? this.props.enabledColors : this.props.enabledColorsLocal}
        onSelect={this.handleChange}
      />
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    saveConfig: () => dispatch(saveConfig()),
    saveGlobalConfig: () => dispatch(saveGlobalConfig()),
    updateEnabledColors: (field, chart) => dispatch(updateEnabledColors(field, chart)),
    updateFieldColors: (field, chart) => dispatch(updateFieldColors(field, chart))
  };
};

const mapStateToProps = state => {
  return {
    app: state.app.app,
    customFields: state.app.data && state.app.data.customFields ? state.app.data.customFields : [],
    enabledColors: state.filters.enabledColors,
    enabledColorsLocal: state.filters[state.filters.chart].enabledColors,
    chart: state.filters.chart,
    dashboard: state.dashboards.selected
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(EnableColors);
export { connected as EnableColors, EnableColors as TestEnableColors };
